import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$siteSlug/')({
  component: SiteIndexPage,
});

function SiteIndexPage() {
  const { siteSlug } = Route.useParams();

  // Redirect to posts by default
  return <Navigate to="/sites/$siteSlug/posts" params={{ siteSlug }} replace />;
}
